let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("3opZo"), load("8h9C3")]).then(() => parcelRequire('29Qqv'));